import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import isEmpty from "../../common/helpers/isEmpty";
import { OrderRow, ValidationError } from "./orderTypes";

type Props = {
  row?: OrderRow;
  validationErrors: ValidationError[];
  position: {
    left: string;
    bottom: string;
  };
};

const OverlappingOrderRowsError = ({
  validationErrors,
  position,
  row,
}: Props) => {
  const { t } = useTranslation("order");

  const overlappingErrorIds = validationErrors
    .filter((item) => item.errorType === "overlappingTimes")
    .map((error) => error.id);

  const overlappingInCurrentBundle = row?.rows.some((item) =>
    overlappingErrorIds.includes(item.id),
  );

  // in additional info, only one bundle can be viewed at a time
  const isAdditionalInfo = row === undefined;

  if (
    (isAdditionalInfo && isEmpty(overlappingErrorIds)) ||
    (!isAdditionalInfo && !overlappingInCurrentBundle)
  )
    return null;

  return (
    <Box minHeight="36px">
      <Typography
        sx={{
          position: "absolute",
          bottom: position.bottom,
          left: position.left,
          maxWidth: "250px",
          color: "#FF505A",
          fontSize: "12px",
        }}
      >
        {t("overlappingShifts")}
      </Typography>
    </Box>
  );
};

export default OverlappingOrderRowsError;
